// @flow

import {useMemo} from 'react';
import {isBrowser} from 'docs/util';

// This function returns Google Tag Manager's dataLayer. When it's activated
// (on the browser), pushing events into the array will cause GTM to record
// them. We just stub it out on the server, though.
export const useGoogleTagManagerClient = (): Array<any> =>
  useMemo(() => {
    let dataLayer = [];

    if (isBrowser) {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      dataLayer = window.dataLayer;
    }

    return dataLayer;
  }, []);
